/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 17:39:40
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-15 10:12:23
 */
// 遍历后台传来的路由字符串，转换为组件对象
import { ControlLayout } from '@/components/layout';
import Index from '@/views/index/index';
import { listMenus } from '@/api/permission';
import localRoute, { personCenterRoute } from '@/menus/localRoute';
import { cloneDeep } from 'lodash';

function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false, prefPath = '') {
	return asyncRouterMap.filter(route => {
		// 将 ruoyi 后端原有耦合前端的逻辑，迁移到此处
		// 处理 meta 属性

		const name = route.name;
		route.meta = {
			title2: name,
			title: name,
			icon: route.icon,
			// noCache: !route.keepAlive,
			showBread: route.showBread,
			useTemplate: route.useTemplate,
			hideMenu: route.hideMenu,
			newFlag: route.newFlag,
		};
		// 路由地址转首字母大写驼峰，作为路由名称，适配keepAlive
		// route.name = toCamelCase(route.path, true);
		route.name = route.path;
		route.hidden = !route.visible;
		route.fullPath = (prefPath ? `${prefPath}/${route.path}` : route.path).replace(/\/+/g, '/');
		// 处理 component 属性
		if (route.children) {
			// 父节点
			route.component = route.parentId !== 0 ? Index : ControlLayout;
		} else {
			// 根节点
			route.component = loadView(route.component);
		}

		// filterChildren
		if (type && route.children) {
			route.children = filterChildren(route.children);
		}
		if (route.children != null && route.children && route.children.length) {
			route.children = filterAsyncRouter(route.children, route, type, route.path);
		} else {
			delete route['children'];
		}
		return true;
	});
}

function filterChildren(childrenMap, lastRouter = false) {
	var children = [];
	childrenMap.forEach((el, index) => {
		if (el.children && el.children.length) {
			if (el.component === 'ParentView' && !lastRouter) {
				el.children.forEach(c => {
					c.path = el.path + '/' + c.path;
					if (c.children && c.children.length) {
						children = children.concat(filterChildren(c.children, c));
						return;
					}
					children.push(c);
				});
				return;
			}
		}
		if (lastRouter) {
			el.path = lastRouter.path + '/' + el.path;
		}
		children = children.concat(el);
	});
	return children;
}

export const loadView = view => {
	// 路由懒加载
	return resolve => require([`@/views/${view}`], resolve);
};
// 设置路由的重定向地址
const setRedict = route => {
	if (route?.children?.length) {
		route.redirect = setRedict(route.children[0]);
	}
	return route.fullPath;
};
export const generateRoutes = () => {
	return new Promise(async resolve => {
		// const route = process.env.NODE_ENV === 'development' ? localRoute : await listMenus();
		const route = await listMenus();
		// 向后端请求路由数据
		const rdata = JSON.parse(JSON.stringify(route));
		const rewriteRoutes = filterAsyncRouter([...rdata, cloneDeep(personCenterRoute)], false, true);
		// rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true });
		// 重新设置所有路由的重定向地址
		rewriteRoutes.forEach(item => {
			if (!item.children || !item.children.length) {
				return;
			}
			item.redirect = setRedict(item.children[0]);
		});

		const [firstRoute] = rewriteRoutes;
		rewriteRoutes.push({ path: '/', redirect: firstRoute.redirect, hidden: true });
		rewriteRoutes.push({ path: firstRoute.redirect, redirect: '/personal', hidden: true });
		resolve(rewriteRoutes);
	});
};
